import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Select, MenuItem, Button, CircularProgress, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

const DEODashboard = () => {
  const [chc, setChc] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [visits, setVisits] = useState([]);
  const [filter, setFilter] = useState('pending');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const storedRole = localStorage.getItem('role');
    const fallbackRole = JSON.parse(localStorage.getItem('loggedInUser'))?.role;
    const role = storedRole || fallbackRole;
    if (role?.toUpperCase() !== 'DEO') {
      navigate('/unauthorized');
    }
  }, [navigate]);

  useEffect(() => {
    fetchVisits();
  }, [filter]);

  const fetchVisits = async () => {
    setLoading(true);
    try {
      const res = await fetch(`/api/visits/deo-status?filter=${filter}&chc=${chc}&start=${startDate}&end=${endDate}`);
      const data = await res.json();
      setVisits(data.visits || []);
    } catch (err) {
      console.error('Error fetching visits:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="p-6 bg-white dark:bg-gray-900 min-h-screen">
      <Typography variant="h5" className="mb-4 text-purple-800 dark:text-purple-300">
        DEO Dashboard / Structured Data Entry
      </Typography>

      <Box className="mb-4 flex flex-wrap items-center gap-4">
        <Select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="completed">Completed</MenuItem>
        </Select>
        <Select value={chc} onChange={(e) => setChc(e.target.value)} displayEmpty>
          <MenuItem value="">All CHCs</MenuItem>
          <MenuItem value="CRHA Keru">CRHA Keru</MenuItem>
          <MenuItem value="CRHA Dhawa">CRHA Dhawa</MenuItem>
          <MenuItem value="CRHA Dundhara">CRHA Dundhara</MenuItem>
          <MenuItem value="UHTC Pratap Nagar">UHTC Pratap Nagar</MenuItem>
        </Select>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="p-2 border rounded text-sm"
        />
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="p-2 border rounded text-sm"
        />
        <Select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="completed">Completed</MenuItem>
        </Select>
        <Button variant="outlined" onClick={fetchVisits}>
          Refresh
        </Button>
      </Box>

      {loading ? (
        <CircularProgress />
      ) : (
        <Table className="bg-white dark:bg-gray-800 rounded shadow">
          <TableHead>
            <TableRow>
              <TableCell>Slip Image</TableCell>
              <TableCell>Visit ID</TableCell>
              <TableCell>Citizen ID</TableCell>
              <TableCell>Diagnosis</TableCell>
              <TableCell>Treatment</TableCell>
              <TableCell>Last Updated</TableCell>
              <TableCell>Entered By</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visits.map((visit) => (
              <TableRow key={visit._id}>
                <TableCell>
                  {visit.slipImageUrl ? (
                    <img
                      src={visit.slipImageUrl}
                      alt="Slip Preview"
                      style={{ width: '80px', height: 'auto', borderRadius: '6px', cursor: 'pointer' }}
                      onClick={() => window.open(visit.slipImageUrl, '_blank')}
                    />
                  ) : (
                    <span className="text-gray-400 italic">No image</span>
                  )}
                </TableCell>
                <TableCell>{visit._id}</TableCell>
                <TableCell>{visit.citizenId}</TableCell>
                <TableCell>{visit.diagnosis || '-'}</TableCell>
                <TableCell>{visit.treatment || '-'}</TableCell>
                <TableCell>{new Date(visit.updatedAt).toLocaleString()}</TableCell>
                <TableCell>{visit.enteredBy || <span className='text-gray-400 italic'>—</span>}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    onClick={() => navigate(`/citizen/${visit.citizenId}/workflow`)}
                  >
                    Open
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  );
};

export default DEODashboard;
